










































































































































































































import Vue from "vue";
import NavListItem from "@/components/app/NavListItem.vue";
import LoginDialog from "@/components/app/LoginDialog.vue";
import ErrorDialog from "@/components/app/ErrorDialog.vue";
import User from "@/User";

export default Vue.extend({
  name: "App",
  components: {
    NavListItem,
    LoginDialog,
    ErrorDialog,
  },
  data: () => ({
    drawer: false,
    group: null,
  }),
  computed: {
    isLoggedIn(): boolean {
      return this.$store.getters.isLoggedIn;
    },
    avatarUri() {
      const user = User.get();
      if (user !== null) {
        return `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}?size=32`;
      }
    },
    user() {
      return User.get();
    },
    dataSnackbar: {
      get: () => {
        const snackbar = localStorage.getItem("data-snackbar");
        if (snackbar === null) {
          return true;
        }

        return false;
      },
      set: (newValue) => {
        localStorage.setItem("data-snackbar", newValue.toString());
      },
    },
  },
  methods: {
    login() {
      User.login();
    },

    logout() {
      User.logout();
    },
  },
});
